module.exports = __webpack_public_path__ + "img/gpt-android-step-3.9ff45e77.png";